<style>
</style>
<template>
  <div class="msgRecord-box">
    <p class="title">短信管理&nbsp;&nbsp;<strong>[ 短信发送记录 ]</strong>
    </p>
    <div class="mb20 order-search-wrap">
      <span>电话号码：</span>
      <el-input v-model.trim="mobilePhone" @keyup.enter.native="getMsgRecord()" style="width:200px;" prefix-icon="el-icon-search" placeholder="输入电话号码" clearable></el-input>
      <span>订单号：</span>
      <el-input v-model.trim="orderNo" @keyup.enter.native="getMsgRecord()" style="width:200px;" prefix-icon="el-icon-search" placeholder="输入订单号" clearable></el-input>
      <span>发送状态：</span>
      <el-select v-model="smsStatus" @change="getMsgRecord()">
        <el-option label="全部" :value="-2"></el-option>
        <el-option label="待发送" :value="-1"></el-option>
        <el-option label="成功" :value="0"></el-option>
        <el-option label="失败" :value="1"></el-option>
      </el-select>
      <span>短信类型：</span>
      <el-select v-model="smsType" @change="getMsgRecord()">
        <el-option label="全部" :value="-1"></el-option>
        <el-option label="普通" :value="1"></el-option>
        <el-option label="营销" :value="2"></el-option>
      </el-select>
      <el-button type="primary" class="ml20" @click="getMsgRecord()" >查询</el-button>
      <span class="addBtn">
        短信计费&nbsp;&nbsp;<strong>[ {{totalFee}} ]</strong>
      </span>
    </div>
    <div class="table-wrapper">
      <el-table :data="mdgRecordData" border v-loading = "loading" highlight-current-row ref="table" :max-height="tableHeight">
        <!-- <el-table-column label="用户ID"  prop="userId"></el-table-column> -->
        <el-table-column label="发送人" prop="userName"  width="200px"></el-table-column>
        <el-table-column label="接收人" prop="mobilePhone" width="200px"></el-table-column>
        <el-table-column label="订单号" prop="orderNo" width="200px"></el-table-column>
        <el-table-column label="短信类型" width="100">
          <template slot-scope="scope">
            <span v-if="scope.row.smsType == 1">普通</span>
            <span v-else>营销</span>
          </template>
        </el-table-column>
        <el-table-column label="短信内容" prop="smsContent" show-overflow-tooltip></el-table-column>
        <el-table-column label="短信回复信息" prop="smsError" show-overflow-tooltip></el-table-column>
        <el-table-column label="扣费次数 (条) "  prop="smsBillingNumber" width="120px"></el-table-column>
        <el-table-column label="发送状态" width="100">
          <template slot-scope="scope">
            <span style="color: #67c23a" v-if="scope.row.smsStatus == 0">发送成功<i class="el-icon-success"></i></span>
            <span style="color: orange" v-else-if="scope.row.smsStatus == -1">发送中<i class="el-icon-warning"></i></span>
            <span style="color: red"  v-else>失败<i class="el-icon-error"></i></span>
          </template>
        </el-table-column>
        <el-table-column label="回调状态" width="100">
          <template slot-scope="scope">
            <span style="color: orange" v-if="scope.row.sStatus == 0">等待<i class="el-icon-warning"></i></span>
            <span style="color: #67c23a" v-else>已通知<i class="el-icon-success"></i></span>
          </template>
        </el-table-column>
        <el-table-column label="发送时间" prop="smsSendTimeStr"  width="200"></el-table-column>
      </el-table>
    </div>
    <div class="txt-r mtop20">
      <el-pagination
        @size-change="sizeChange"
        @current-change="currentChange"
        :current-page="pageNum"
        :page-sizes="[20, 50, 100]"
        :page-size=pageSize
        layout="total, sizes, prev, pager, next, jumper"
        :total=total>
      </el-pagination>
    </div>
  </div>
</template>
<script>
import api from '../../server/api.js'
export default {
  name: "msgRecord",
  data(){
    return{
      tableHeight: 100,
      loading:false,
      orderNo:"",
      totalFee : 0,
      smsType : -1,
      smsStatus:-2,
      mobilePhone:"",
      pageSize: 20,//当前显示条数
      pageNum: 1,//当前页数
      total: 0,//总数
      mdgRecordData: [],
    };
  },
  created(){
    let orderNo = this.$route.params.orderNo;
    if(orderNo && orderNo.length > 0 ){
      this.orderNo = orderNo;
    }
    this.getMsgRecord()
  },
  methods: {
    getMsgRecord(){//获取列表
      let data = {
        "start": this.pageNum,
        "length": this.pageSize,
        "smsType": this.smsType == -1 ? null : this.smsType,
        // "startTime":
        // "endTime":
        "orderNo": this.orderNo,
        "smsStatus": this.smsStatus == -2 ? null : this.smsStatus,
        "mobilePhone": this.mobilePhone
      }
      this.loading =true;
      api.getRecordList({data:data}).then(res => {
        this.loading =false;
        if(res.status == 'success'){
          this.tableHeight =
            window.innerHeight - this.$refs.table.$el.offsetTop - 100;
          this.mdgRecordData = res.data.recordDtoList;
          this.total = res.data.totalCount;
          this.totalFee = res.data.totalFee;
        }
      })
    },
    sizeChange(v){//切换显示条数
      this.pageSize = v;
      this.getMsgRecord();
    },
    currentChange(v){//切换页数
      this.pageNum = v;
      this.getMsgRecord();
    },
  },
  components: {
    
  }
}
</script> 
  




// WEBPACK FOOTER //
// src/view/autograph/msgRecord.vue